import { ShieldAlert, LogOut } from 'lucide-react';
import { Button } from './ui/button';

export default function MembershipBlock({ onLogout }) {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center p-6" data-testid="membership-block">
      <div className="max-w-md w-full text-center">
        <div className="bg-[#18181B] border border-[#EF4444]/30 rounded-sm p-8 shadow-lg">
          <div className="bg-[#EF4444]/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldAlert className="w-10 h-10 text-[#EF4444]" />
          </div>

          <h1 className="text-3xl font-heading font-black uppercase tracking-tighter text-[#FAFAFA] mb-3">
            Access Restricted
          </h1>

          <p className="text-[#A1A1AA] text-base mb-6 leading-relaxed">
            Your membership payment is currently <span className="text-[#EF4444] font-bold">overdue</span>. 
            Your access to R&R Elite Fitness has been temporarily suspended.
          </p>

          <div className="bg-[#09090B] border border-[#27272A] rounded-sm p-4 mb-6">
            <p className="text-sm text-[#FAFAFA] font-semibold uppercase tracking-wide mb-2">
              To restore access:
            </p>
            <p className="text-sm text-[#A1A1AA]">
              Please send your <span className="text-[#CCFF00] font-semibold">Proof of Payment</span> to the Head Coach. 
              Once verified, your access will be restored immediately.
            </p>
          </div>

          <Button
            onClick={onLogout}
            data-testid="blocked-logout-button"
            className="w-full bg-transparent border border-[#27272A] text-[#A1A1AA] hover:bg-[#27272A] hover:text-[#CCFF00] uppercase tracking-wider transition-all rounded-sm"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>

        <div className="mt-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_wod-trainer/artifacts/rhui1jxy_R%26R%20ELITE_20250812_172035_0000.png"
            alt="R&R Elite Fitness"
            className="w-16 h-16 object-contain mx-auto opacity-30"
          />
        </div>
      </div>
    </div>
  );
}
